import { widgetIds } from './keys.ts';

export const sidebarConfig = {
  sidebar: [
    {
      settings: {},
      widgetId: 'publication-widget',
      widgetNamespace: 'sidebar-builtin',
    },
    {
      settings: {},
      widgetId: widgetIds.ourApp,
      widgetNamespace: 'app',
    },
    {
      settings: {},
      widgetId: 'content-preview-widget',
      widgetNamespace: 'sidebar-builtin',
    },
    {
      settings: {},
      widgetId: 'translation-widget',
      widgetNamespace: 'sidebar-builtin',
    },
    {
      settings: {},
      widgetId: 'versions-widget',
      widgetNamespace: 'sidebar-builtin',
    },
    {
      disabled: true,
      widgetId: 'releases-widget',
      widgetNamespace: 'sidebar-builtin',
    },
    {
      disabled: true,
      widgetId: 'incoming-links-widget',
      widgetNamespace: 'sidebar-builtin',
    },
  ],
};
